<template>
    <div class="container-fluid">
        <div class="row social">
            <div class="social-title">
                <h1>Social</h1>
            </div>
            <carousel :perPageCustom="[[320, 1], [768, 1], [1000, 3]]" :scrollPerPage="true">
                <slide class="col-md-4 social-item" v-for="(noticia, key) in noticias" :key="key">
                    <div class="social-item-thumb">
                        <img :src="noticia.image" />
                    </div>
                    <div class="social-item-content">
                        <p>{{ noticia.dataFormatada }}</p>
                        <h3>{{ noticia.titulo }}</h3>
                        <p>{{ noticia.descricao }}</p>
                        <small>Leia+</small>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide
    },

    data(){
        return {
            noticias : [
                {
                    titulo: 'Resultado concurso cultural "torcida premiada"',
                    descricao: 'É um prazer estarmos juntos nos momentos mais importantes de sua vida, seja no seu almoço, no seu jantar ou em todas as suas comemorações.',
                    dataFormatada: '07/07/2018',
                    image: require('../assets/social/s1.jpg'),
                },
                {
                    titulo: 'Funada completa 66 anos',
                    descricao: 'Esta é a Refrigerantes Funada, presente a mais de 6 décadas na vida e na mesa de várias famílias em São Paulo, Paraná, Mato Grosso do Sul, Paraguai, Bolívia e Japão.',
                    dataFormatada: '08/07/2018',
                    image: require('../assets/social/s2.jpg'),
                },
                {
                    titulo: 'Novidades na linha 8 segundos',
                    descricao: ' O sabor que a galera aprovou continua o mesmo, mas agora em versão 1 litro e com muito mais vantagens.',
                    dataFormatada: '10/07/2018',
                    image: require('../assets/social/s3.jpg'),
                },
                {
                    titulo: 'Funada completa 66 anos',
                    descricao: 'Esta é a Refrigerantes Funada, presente a mais de 6 décadas na vida e na mesa de várias famílias em São Paulo, Paraná, Mato Grosso do Sul, Paraguai, Bolívia e Japão.',
                    dataFormatada: '08/07/2018',
                    image: require('../assets/social/s2.jpg'),
                },
                {
                    titulo: 'Novidades na linha 8 segundos',
                    descricao: ' O sabor que a galera aprovou continua o mesmo, mas agora em versão 1 litro e com muito mais vantagens.',
                    dataFormatada: '10/07/2018',
                    image: require('../assets/social/s3.jpg'),
                },
                {
                    titulo: 'Resultado concurso cultural "torcida premiada"',
                    descricao: 'É um prazer estarmos juntos nos momentos mais importantes de sua vida, seja no seu almoço, no seu jantar ou em todas as suas comemorações.',
                    dataFormatada: '07/07/2018',
                    image: require('../assets/social/s1.jpg'),
                }
            ]
        }
    }
}
</script>

<style scoped>
.container-fluid {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 50px;
}

.social {
    font-family: 'Bambino';
    text-transform: uppercase;
    margin-bottom: 50px;
    display: block;
    width: 100%;
}

.social-title h1 {
    padding-left: 20px;
    font-size: 10pt;
}

.social-item {
    padding: 20px;
}

.social-item h3 {
    font-size: 10pt;
    font-weight: bold;
}

.social-item p {
    font-size: 9pt;
    font-weight: 400;
    text-transform: lowercase;
}

.social-item small {
    position: absolute;
    bottom: 0;
}

.social-item-thumb img {
    width: 100%;
}

.social-item-content {
    margin-top: 15px;    
}

@media only screen and (min-width: 320px) and (max-width: 1024px){
    .row {
        margin-left: 0px;
    }

    .container-fluid {
        padding-top: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Social.vue